<template>
    <div>
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                title="Deployment: Live"
                :ok-disabled="!validate"
                ok-text="Deployment starten"
                :loading="deployLiveLoading"
                @ok="submit"
                @cancel="$emit('input', false)">
            <Input v-model="message" label="Beschreibung"
                   :error-messages="message_errors" :required="true"
                   @input="$v.message.$touch()"
                   @blur="$v.message.$touch()"
            />
            <Toggle v-for="(toggle, i) in formSwitches" :key="'switch_'+i"
                    :label="toggle.label" :hide-details="i === formSwitches.length -1 ? 'auto' : true"
                    v-model="$data[toggle.vModel]" :error-messages="deploy_errors"
                    @input="$v[toggle.vModel].$touch()"
                    @blur="$v[toggle.vModel].$touch()"
            />
        </Dialog>
    </div>
</template>

<script>
import Dialog from "../../../components/Dialog";
import Input from "../../../components/Inputs/Input";
import Toggle from "../../../components/buttons/Toggle";
import Utils from "../../../scripts/Utils";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";

function deployReq() {
    return this.module === 1 || this.local === 1 || this.config === 1
}

export default {
    name: "DeployLiveDialog",
    components: {Toggle, Input, Dialog},
    props: ['value'],
    mixins: [validationMixin],
    validations: {
        message: {required},
        module: {validateDeploy: deployReq},
        local: {validateDeploy: deployReq},
        config: {validateDeploy: deployReq},
    },
    data: () => {
        return {
            message: null,
            module: 0,
            local: 0,
            config: 0,
        }
    },
    computed: {
        formSwitches() {
            return [
                {
                    vModel: 'module',
                    label: 'Module deployen?'
                },
                {
                    vModel: 'local',
                    label: 'Aktuelle Local deployen?'
                },
                {
                    vModel: 'config',
                    label: 'Aktuelle Konfiguration deployen?'
                },
            ];
        },
        message_errors() {
            return Utils.handleError(this, 'message', 'Beschreibung ist erforderlich.');
        },
        deploy_errors() {
            return Utils.handleError(this, 'config', {validateDeploy: 'Bitte angeben, was deployed werden soll.'});
        },
        validate() {
            return this.message_errors.length === 0 && this.deploy_errors.length === 0;
        },
        deployLiveLoading() {
            return this.$store.state.deploy.deploy_live_loading;
        }
    },
    methods: {
        init() {
            this.message = null;
            this.module = 0;
            this.local = 0;
            this.config = 0;
        },
        async submit() {
            this.$v.$touch();
            if (this.validate) {
                this.$emit('submit', this.getBody());
            }
        },
        getBody() {
            return {
                message: this.message,
                module: this.module,
                local: this.local,
                config: this.config
            }
        }
    },
    watch: {
        value(newValue) {
            if (!newValue) {
                this.message = null;
                this.module = 0;
                this.local = 0;
                this.config = 0;
                this.$v.$reset();
            }
        }
    },
}
</script>

<style scoped>

</style>